import React from 'react';
import { ChannelMessageAttachmentType } from 'shared/types/graphql';

interface IImageAttachmentProps {
  url: string;
  filename: string;
  setPreviewData: (fileUrl: string, attachmentType: ChannelMessageAttachmentType, fileName: string) => void;
}

const ImageAttachment = ({ url, filename, setPreviewData }: IImageAttachmentProps): JSX.Element => {
  return (
    <img
      src={url}
      alt={filename || 'Alternate text not available'}
      onClick={(): void => setPreviewData(url || '', ChannelMessageAttachmentType.Image, filename || '')}
    />
  );
};

export default ImageAttachment;
